import styled from "styled-components";
import ShowTierRow from "./ShowTierRow";

const FullScreenButton = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 30px;
  height: 30px;
  background-color: #ffffff;
  display: grid;
  place-items: center;
  border-radius: 2px;
  outline: none;
`;

const TierListContainer = styled.div`
  overflow: auto;
  background-color: #000000;
  min-width: 100%;
  min-height: 500px;
  position: relative;
`;

function ShowTierListContainer(props) {
  const { tierList } = props;
  const tierListData = tierList.data;

  const handleFullScreen = (e) => {
    const parentContainer = e.target.parentNode;
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement
    ) {
      closeFullscreen();
    } else {
      makeFullScreen(parentContainer);
    }
  };

  function makeFullScreen(elem) {
    console.log("Clicked");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
  }
  /* 
  console.log("tierListData.rowOrder :", tierListData.rowOrder);
  console.log("tierListData :", tierListData);
  tierListData.rowOrder.forEach((row) => {
    console.log("tierListData.rows[row].title :", tierListData.rows[row].title);
    console.log("tierListData.rows[row].color :", tierListData.rows[row].color);
    console.log(
      "tierListData.rows[row].itemIds :",
      tierListData.rows[row].itemIds
    );
    console.log("tierListData.items :", tierListData.items);
  });
 */
  return (
    <>
      <TierListContainer id="create-tier-list-container">
        {tierListData.rowOrder.map((row) => {
          return (
            <ShowTierRow
              key={tierListData.rows[row].title}
              row={row}
              letter={tierListData.rows[row].title}
              color={tierListData.rows[row].color}
              items={tierListData.rows[row].itemIds}
              itemMap={tierListData.items}
              isDroppable={false}
            />
          );
        })}
        <FullScreenButton onClick={handleFullScreen}>[ ]</FullScreenButton>
      </TierListContainer>
    </>
  );
}

export default ShowTierListContainer;
